import SpineApi, { SPINE_BASE_API_URL } from '@/api/base/SpineApi'

export default {
  getShout(businessUnit) {
    return SpineApi.get(`${SPINE_BASE_API_URL}/api/internal/active_shout/${businessUnit}`)
  }
}
